import React, { Component } from 'react';
import Player from '../services/player.js'
import { Debounce } from 'react-throttle';

import '../../css/Lyrics.css';


class Lyrics extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      id: undefined,
      hidden: props.hidden,
      lyrics: {lines: []}
    }
  }

  componentWillReceiveProps(newProps) {
    if (this.state.hidden !== newProps.hidden) {
      this.setState({
        hidden: newProps.hidden
      }, () => {
        this.refs.lyrics.scrollTop = 0;
      });
    }
  }

  componentDidMount() {
    this.refreshTrackData();
  }

  componentDidUpdate() {
    this.refreshTrackData();
  }

  refreshTrackData() {
    let track = Player.currentTrack;

    if (track && (!this.state.id || (this.state.id !== track.id))) {
      this.refs.artist.value = track.artist;
      this.refs.track.value = track.track;
      this.setState({lyrics: {lines: ['Loading lyrics...']}, id: track.id});
      this.updateLyrics();
    }
  }

  updateLyrics() {
    Player.getLyrics({artist: this.refs.artist.value, track: this.refs.track.value}, (lyrics) => {
      this.setState({lyrics: lyrics});
    });
  }

  render() {

    let url = this.state.lyrics.url ? this.state.lyrics.url : `https://vagalume.com.br`;

    let lyrics = this.state.lyrics.lines.map((line, index) => {
      return (<li key={index}>{line}</li>);
    });
   
    return (

      <div id="lyrics" style={ {display: this.state.hidden ? 'none' : 'block'} }>
      
        <h2>Lyrics</h2>

        <a className="clickable vagalume" target="_blank" href={url}>Powered by Vagalume <i className="fontastic vagalume"></i></a>

        <Debounce time="300" handler="onChange">
          <input ref="artist" type="text" 
          onChange={this.updateLyrics.bind(this)}
          className="searchBar" placeholder="Artist"/>
        </Debounce>   

        <Debounce time="300" handler="onChange">
          <input ref="track" type="text" 
          onChange={this.updateLyrics.bind(this)} 
          className="searchBar" placeholder="Track"/>        
        </Debounce>

        <a onClick={this.updateLyrics.bind(this)} className="clickable"><i className="icon-search"></i></a>

        <ul className="text" ref="lyrics">
          {lyrics}
        </ul>

      </div>
    );
  }
}

export default Lyrics;



// WEBPACK FOOTER //
// ./src/js/components/Lyrics.jsx